import React from 'react'
import NavLink from '../Routes/NavLink'

import FloorPlanCard from './FloorPlanCard'

export default class FloorPlanList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const floorPlanData = this.props.data;
        const activateLayout = this.props.activateLayout;
        return (
            <div class="row">
                {floorPlanData != null && floorPlanData.length > 0 ? ( 
                    floorPlanData.map(function(floorPlan, index){
                        const floorData = floorPlan.data;
                        return (
                            <FloorPlanCard key={floorData.building_floor_plan_id} floorData={floorData} activateLayout={activateLayout}/>
                        )
                    })
                ) : (
                        <div class="col-md-4">
                            <p>You have no floor plans.</p>
                        </div>
                    )
                }
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/FloorPlans/FloorPlanList.jsx